import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap'

import firebase from "../../firebase/firebase-config";
import { useParams } from 'react-router-dom';
import ProductCard from './ProductCard';


const User_Specific_Products = () => {
    const params = useParams();
    const [all_Products, setall_Products] = useState([])
    const [userID, setUUser] = useState({})

    const [query, setquery] = useState('')

    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };



    const get_all_ProductsbyUser = () => {
        firebase.firestore().collection('post').where('addedById', '==', params.id).onSnapshot((order) => {
            const orders_data = [];
            order.forEach(element => {
                orders_data.push(element.data());
            });
            console.log(orders_data, 'this is order data');
            setall_Products(orders_data);

        })
    }
    async function GetMyUser() {
        try {

            const Myuser = await firebase.firestore().collection('users').doc(params.id).get();
            setUUser(Myuser.data());
            Myuser.data();
        } catch (error) {
            console.log(error);
        }



    }
    useEffect(() => {
        get_all_ProductsbyUser();
        GetMyUser();
    }, []);

    const search = (data) => {
        return data.filter((order_search) => order_search.orderId.toLowerCase().includes(query) || order_search.isCompleted.toLowerCase().includes(query) || order_search.products.toLowerCase().includes(query) || order_search.contact.toLowerCase().includes(query)

        );
    }
    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">

                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any Order..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                </Row>
                <Row className="d-flex justify-content-center  mt-4 align-items-center">
                    <button
                        className={toggleState === 1 ? "tabs active-tabs btn btn-primary btn-sm" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(1)}
                    >
                        Total Products({all_Products.length})
                    </button>
                    {/* <button
                    className={toggleState === 2 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                    onClick={() => toggleTab(2)}
                >
                    Pending Orders({all_pendingorders.length})
                </button>
                <button
                    className={toggleState === 3 ? "tabs active-tabs btn-sm btn btn-primary" : "tabs btn-sm btn btn-default"}
                    onClick={() => toggleTab(3)}
                >
                    Approved Orders({all_Approvedorders.length})
                </button>
                <button
                    className={toggleState === 4 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                    onClick={() => toggleTab(4)}
                >
                    Production Orders({all_Productionorders.length})
                </button>
                <button
                    className={toggleState === 5 ? "tabs active-tabs btn-sm btn btn-primary" : "tabs btn btn-sm btn-default"}
                    onClick={() => toggleTab(5)}
                >
                    Out For Delivery Orders({all_OFDorders.length})
                </button>
                <button
                    className={toggleState === 6 ? "tabs active-tabs btn-sm btn btn-primary" : "tabs btn btn-sm btn-default"}
                    onClick={() => toggleTab(6)}
                >
                    Delivered Orders({all_Deliveredorders.length})
                </button> */}
                </Row>
                <Row className='mt-4'>
                    <Col className='col-lg-4'>
                    </Col>
                    <Col className='col-lg-4'>
                        <Card className="card-user shadow-lg">

                            <CardText />
                            <div className=" d-flex   justify-content-center  " >
                                <div className=" d-flex ">
                                    <img
                                        alt="..."
                                        className="avatar_single_user"
                                        src={userID.profilePicture}
                                    />
                                    {/* <div>{user?.isOnline == false ? <div className="px-4 d-flex justify-content-center align-items-center  font-weight-bolder" style={{ backgroundColor: '#DD011B', borderRadius: '20px' }}> <p className='font-weight-bold'>Ofline</p>    </div> : <div className="px-4 d-flex justify-content-center align-items-center " style={{ backgroundColor: '#30DF1E', borderRadius: '20px' }}> <p className="font-weight-bold">Online</p>    </div>}
            </div> */}
                                    <div className="ml-2 mt-2">
                                        <div className='d-flex'>
                                            <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{userID.username}</p>
                                        </div>
                                        <p className="description" style={{ fontSize: '12px' }}>{userID.fullName}</p>

                                    </div>

                                </div>
                                <div>

                                    <p className="description ml-5 bg-info px-2 ppy-1 rounded " style={{ fontSize: '14px' }}>Beyown user</p>
                                </div>


                            </div>

                        </Card>
                    </Col>
                    <Col className='col-lg-4'>
                    </Col>
                </Row>


                <div className='mt-4'>
                    <div className="content-tabs">
                        <div className={toggleState === 1 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_Products.filter(order => order.addedById.toLowerCase().includes(query)).map((order, i) => (


                                    <ProductCard data={order} key={i} />


                                ))}
                            </div>



                        </div>


                    </div>

                </div>


            </div>

        </>
    )
}
export default User_Specific_Products